import { Pagination, Product } from '@deliveries-app/models';
import { ProductPayload } from '@deliveries-app/services';

import { ProductActions, ProductActionTypes } from './actionTypes';

export interface ProductReducerState {
  loading: boolean;
  message: string;
  error: string;
  errors: string[];
  _metadata?: Pagination;
  products: Product[];
  product: ProductPayload;
}

const initialState: ProductReducerState = {
  loading: false,
  message: '',
  error: '',
  errors: [],
  _metadata: {
    page: 1,
    perPage: 2,
    total: 1,
    pages: 1,
  },
  products: [],
  product: {
    code: '',
    name: '',
    volume: '',
    weight: '',
    retail_price: null,
    trade_price: null,
  },
};

export default function productsReducer(
  state = initialState,
  action: ProductActions
) {
  switch (action.type) {
    case ProductActionTypes.GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.data,
        _metadata: action.payload._metadata,
        message: ProductActionTypes.GET_ALL_PRODUCTS_SUCCESS,
        error: '',
      };
    case ProductActionTypes.GET_ALL_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: ProductActionTypes.GET_ALL_PRODUCTS_FAILURE,
      };
    case ProductActionTypes.UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: state.products.map((obj) => {
          if (obj.id === action.payload.id) {
            return action.payload;
          }

          return obj;
        }),
        message: ProductActionTypes.UPDATE_PRODUCT_SUCCESS,
        error: '',
      };
    case ProductActionTypes.UPDATE_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        message: ProductActionTypes.UPDATE_PRODUCT_FAILURE,
        errors: action.payload.errors,
      };
    case ProductActionTypes.CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: [action.payload, ...state.products],
        message: ProductActionTypes.CREATE_PRODUCT_SUCCESS,
        error: '',
      };
    case ProductActionTypes.CREATE_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        message: ProductActionTypes.CREATE_PRODUCT_FAILURE,
        errors: action.payload.errors,
      };
    case ProductActionTypes.DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: state.products.filter(
          (product) => product.id !== action.payload
        ),
        message: ProductActionTypes.DELETE_PRODUCT_SUCCESS,
        error: '',
      };
    case ProductActionTypes.DELETE_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: ProductActionTypes.DELETE_PRODUCT_FAILURE,
      };
    default:
      return state;
  }
}
